<template>
    <div>
        <br>
        <v-alert
            v-model="alertSuccess"
            close-text="Close Alert"
            dense
            text
            type="success"
            dismissible
            style="text-align: left"
        >
            {{ informText }}
        </v-alert>

        <v-alert
            v-model="alertError"
            close-text="Close Alert"
            dense
            text
            type="error"
            dismissible
            dark
            style="text-align: left"
        ></v-alert>
        <v-col cols="12" style="text-align:right">
            <v-btn color="info" @click="exportByBatch">Export By Batch</v-btn>
            &nbsp;
            <v-btn color="teal" @click="exportByProduct"><span style="color: white;">Export By Product</span></v-btn>
        </v-col>
        
        <v-simple-table fixed-header height="95vh">
            <template v-slot:default>
                <thead>
                    <tr height="80px">
                        <th class="cell-border" colspan="2">
                            <v-text-field label="Search..." dense v-model="search"></v-text-field>
                        </th>
                        <th class="cell-border" colspan="4" style="background-color: white;">
                            <v-text-field type="number" label="Minimum Inventory Level" dense v-model="filterByQty"></v-text-field>
                        </th>
                    </tr>
                    <tr>
                        <th class="cell-border">Thumbnail</th>
                        <th class="cell-border"><div class="resize-div">Product</div></th>

                        <th class="cell-border"><div class="resize-div">Type</div></th>

                        <th class="cell-border"><div class="resize-div">Variant</div></th>
                        <th class="cell-border"><div class="resize-div">Total Qty</div></th>

                        <th class="cell-border"><div class="resize-div">Location</div></th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(i,indexi) of listInventory">
                        <template v-for="(j,indexj) of i.variants">
                            <tr v-if="indexj == 0" :key="indexi + '-' + indexj">
                                <td class="cell-border" :rowspan="i.variants.length">
                                    <img :src="i.product_thumbnail" style="width:150px"/>
                                </td>
                                <td class="cell-border" :rowspan="i.variants.length">
                                    <div>{{ i.product_code }}</div>
                                    <div>{{ i.product_title }}</div>
                                </td>
                                <td class="cell-border" :rowspan="i.variants.length">
                                    {{ i.product_type }}
                                </td>
                                <td class="cell-border" v-if="indexj == 0">{{ j.variant_name }}</td>
                                <td class="cell-border" v-if="indexj == 0">
                                    <template v-if="parseInt(filterByQty) > parseInt(j.total_quantity)">
                                        <b style="color:red">{{ j.total_quantity }}</b>
                                    </template>
                                    <template v-else>{{ j.total_quantity }}</template>                                 
                                </td>
                                <td class="cell-border" v-if="indexj == 0">{{ j.location }}</td>
                            </tr>
                            <tr v-else :key="indexi + '-' + indexj + '1'">
                                <td class="cell-border">{{ j.variant_name }}</td>
                                <td class="cell-border">
                                    <template v-if="parseInt(filterByQty) > parseInt(j.total_quantity)">
                                        <b style="color:red">{{ j.total_quantity }}</b>
                                    </template>
                                    <template v-else>{{ j.total_quantity }}</template>
                                </td>
                                <td class="cell-border">{{ j.location }}</td>
                            </tr>
                        </template>
                    </template>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>

    import axios from "axios";

    export default {
        name:"WarehouseInventory",

        data: () => ({
            loading: false,
            informText:'',
            roles: [],
            alertError: false,
            alertSuccess: false,
            search:"",

            listInventory: [],
            listInventoryBackup:[],
            filterByQty:null,
            
        }),


        watch:{
            search(){
                this.searchItem();
            }
        },

        methods:{
            async loadData(){
                var currentSession = await this.$root.$refs.App.currentSession(
                    "rawMaterial-loadData"
                );

                if (currentSession.accessToken) {
                    await axios
                    .get(window.domain + "warehouse-inventory", {
                        headers: { Authorization: currentSession.accessToken },
                    })
                    .then((response) => {
                        console.log('response: ',response);
                        this.listInventory = response.data.data.inventory;
                        this.listInventoryBackup = JSON.parse(JSON.stringify(response.data.data.inventory));
                    })
                    .catch((error) => {
                        console.log("Error:", error);
                        this.loading = false;
                        this.orders = [];
                    });
                } else {
                    console.log(
                    "currentSession rawMaterial-loadData-undefined: ",
                    currentSession
                    );
                }
            },

            searchItem(){
                console.log('this.search: ',this.search)
                if(this.search != ''){
                    this.listInventory = this.listInventoryBackup.filter(t => 
                        t.product_code.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
                        t.product_title.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
                        t.product_type.toLowerCase().indexOf(this.search.toLowerCase()) > -1 
                    )
                }else{
                    this.listInventory = JSON.parse(JSON.stringify(this.listInventoryBackup));
                }
                console.log('this.listInventory: ',this.listInventory,' - this.listInventoryBackup',this.listInventoryBackup)
            },

            async exportByBatch(){
                
                var currentSession = await this.$root.$refs.App.currentSession(
                    "exportByBatch-saveData"
                );
                //console.log('currentSession: ',currentSession.accessToken)
                if (currentSession.accessToken) {
                    await fetch(window.domain + "warehouse-inventory/export-by-batch", {
                        method: "POST",
                        headers: { Authorization: currentSession.accessToken },
                        })
                        .then((response) => response.json())
                        .then((data) => {
                            console.log("data: ", data);
                            if(data.error_message != ''){
                                this.alertError = false
                                this.informText = data.error_message
                            }else{
                                this.alertSuccess = true
                                this.informText = this.informText = "We're currently preprocessing your order data. System will send a file to your email when completed."
                            }

                            //this.loadData()
                            this.$root.$refs.warehouseImport.loadData()
                        })
                        .catch((error) => console.log("Error: ", error));
                }
            },

            async exportByProduct(){
                var currentSession = await this.$root.$refs.App.currentSession(
                    "exportByProduct-saveData"
                );
                //console.log('currentSession: ',currentSession.accessToken)
                if (currentSession.accessToken) {
                    await fetch(window.domain + "warehouse-inventory/export-by-product", {
                        method: "POST",
                        headers: { Authorization: currentSession.accessToken },
                        })
                        .then((response) => response.json())
                        .then((data) => {
                            console.log("data: ", data);
                            if(data.error_message != ''){
                                this.alertError = false
                                this.informText = data.error_message
                            }else{
                                this.alertSuccess = true
                                this.informText = this.informText = "We're currently preprocessing your order data. System will send a file to your email when completed."
                            }

                            //this.loadData()
                            this.$root.$refs.warehouseImport.loadData()
                        })
                        .catch((error) => console.log("Error: ", error));
                }
            },
        },

        async mounted(){
            
            this.roles = await this.$cookies.get("inventory");
            console.log("this.roles: ",this.roles)
            if (this.roles.list_inventory) {
                console.log("OK");
            } else {
                this.$router.push("/not-authorized");
            }

            await this.loadData();
        }
    }
</script>

<style lang="scss" scoped>
.cell-border{
    border: thin solid rgba(0, 0, 0, 0.12);
}

.cell-color{
    background-color: #D9EAD3;
}

.resize-div{
    resize: both;
  overflow: auto;
  display: block;
}

</style>